module.exports = __webpack_public_path__ + "media/06.2cbffa7c.mp4";